import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function DisclaimerBanner() {
  return (
    <div className="bg-red-50 border-y border-red-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-center space-x-2 text-red-700">
          <AlertTriangle className="h-5 w-5 text-red-600" />
          <p className="text-sm">
            We are a third-party repair service provider for out-of-warranty products only.
            <Link to="/disclaimer" className="ml-1 text-red-600 hover:text-red-700 underline">
              Learn more →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}